import useSettingsGlobals from '@/composables/useSettingsGlobals';
import useSpotGlobals from '@/composables/useSpotGlobals';

// Per-spot persistence of the Forecast Table's single selected model id. The
// single-select analogue of useGraphModelStorage: on the web a localStorage
// object keyed by spotId (the same `FxTableSettings` object the legacy FxTable
// reads/writes, so selections stay compatible), and native messaging inside the
// app webview (reproducing the legacy FxTable `modelChanged` callback).
export const useForecastTableModelStorage = (storageKey = 'FxTableSettings') => {
  const { $WEB_VIEW, $PLATFORM } = useSettingsGlobals();
  const spotGlobals = useSpotGlobals();

  // Normalize to a number so selections compare cleanly against the API model
  // ids (legacy entries / native globals may be strings).
  function toId(value) {
    if (value == null || value === '') return null;
    const id = Number(value);
    return Number.isNaN(id) ? null : id;
  }

  function readStore() {
    // Matches the legacy FxTable format via jweather's storage helpers.
    return (window.jweather && window.jweather.getLocalObject(storageKey)) || {};
  }

  function read(spotId) {
    if ($WEB_VIEW) return toId(spotGlobals.$FX_MODEL_ID);

    if (spotId == null || spotId === '') return null;

    return toId(readStore()[spotId]);
  }

  function save(spotId, modelId) {
    if (!$WEB_VIEW) {
      if (spotId == null || spotId === '') return;

      const store = readStore();
      store[spotId] = modelId;
      window.jweather && window.jweather.saveLocalObject(storageKey, store);
      return;
    }

    if ($PLATFORM === 'android') {
      if (spotId != null && spotId !== '') alert(['modelchanged', spotId, modelId].join(','));
      return;
    }

    try {
      window.webkit.messageHandlers.observe.postMessage({ type: 'fx-model-id', fxModelId: modelId });
    } catch (error) {
      console.warn('Error saving selected forecast table model:', error);
    }
  }

  return { read, save };
};
